import dayjs from "dayjs";
class FormUtil {
  static buildForm = tableInfo => {
    const TableItem = [];
    const defaultTableItem = {
      prop: "", // 字段名字
      label: "", // 对应标识
      minWidth: 100, // 默认最小宽度
      tip: true // 默认自适应
    };
    // 判断是否存在 或者是否为数组
    // lodash 判断是否为数组
    if (!tableInfo.tableHeader || !_.isArray(tableInfo.tableHeader)) {
      // 抛出错误
      throw new Error("这里需要传入数组");
    }
    tableInfo.tableHeader.forEach(item => {
      if (item.prop === "oper") {
        TableItem.push(_.cloneDeep(item));
        return;
      }
      TableItem.push(_.merge(_.cloneDeep(defaultTableItem), _.cloneDeep(item)));
    });
    const MyTableInfo = {
      loading: tableInfo.loading,
      tableHeader: TableItem
    };
    console.log(MyTableInfo);
    return MyTableInfo;
  };
  // 值转化
  static dateFormat = (date, fmt = "YYYY-MM-DD") => {
    if (!date) {
      return "";
    } else if (date === "1900-01-01T00:00:00") {
      return "";
    } else {
      // locale("zh-cn") 兼容英文
      return dayjs(date)
        .locale("zh-cn")
        .format(fmt);
    }
  };
}

export default FormUtil;



// WEBPACK FOOTER //
// ./src/components/TableRealy/utils.js